  <template>
    <v-container fluid class="pa-0">
        <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
          <v-row no-gutters>
            <v-col cols="12" md="6" lg="4" sm="6" xs="12" class="my-0 py-0">
              <div class="d-flex grow flex-wrap">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  {{schedulingStatus }} Schedule
                </div>
              </div>
            </v-col>
            <v-card-actions>
                <router-link slot="right" :to="{ name: 'createViewSchedule' }">
                  <v-btn
                    elevation="1"
                    absolute
                    right
                    top>
                    <v-icon left>mdi-arrow-left</v-icon>back</v-btn
                  >
                </router-link>
              </v-card-actions>
          </v-row>
            <div class="d-flex scheduling-main">
              <div class="calender-left-section">

                <v-date-picker
                  v-model="selectedDateString"
                  :value="selectedDateString"
                  @input="onDateChange"
                />

                <div class="drag-drop-boxes">
                  <div class="drag-heading">Centers</div>
                  <table>
                    <thead>
                      <tr>
                        <th class="txt-center bg-gold">Gold Centers</th>
                        <th class="txt-center bg-silver">Silver Centers</th>
                        <th class="txt-center bg-bronze">Bronze Centers</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="gold-col">
                          <draggable
                            v-model="goldBoxes"
                            :group="{ name: 'gold', pull: 'clone', put: false }"
                            @start="onDragStart('gold')"
                            @end="onDragEnd"
                          >
                            <div
                              v-for="(box, index) in goldBoxes"
                              :key="index"
                              class="draggable-box gold testing"
                              @dragstart="onDragStartItem(box, 'gold', index)"
                              draggable="true"
                              @mouseover="goldHoveredName = box.companyName"
                              @mouseleave="goldHoveredName = ''"
                            >
                              {{ box.centerCode }}
                              <span v-if="goldHoveredName" class="tooltip">{{ goldHoveredName }}</span>
                            </div>
                          </draggable>
                        </td>
                        <td class="silver-col">
                          <draggable
                            v-model="silverBoxes"
                            :group="{ name: 'silver', pull: 'clone', put: false }"
                            @start="onDragStart('silver')"
                            @end="onDragEnd"
                          >
                            <div
                              v-for="(box, index) in silverBoxes"
                              :key="index"
                              class="draggable-box silver"
                              @dragstart="onDragStartItem(box, 'silver', index)"
                              draggable="true"
                              @mouseover="silverHoveredName = box.companyName"
                              @mouseleave="silverHoveredName = ''"
                            >
                              {{ box.centerCode }}
                              <span v-if="silverHoveredName" class="tooltip">{{ silverHoveredName }}</span>
                            </div>
                          </draggable>
                        </td>
                        <td class="bronze-col">
                          <draggable
                            v-model="bronzeBoxes"
                            :group="{ name: 'bronze', pull: 'clone', put: false }"
                            @start="onDragStart('bronze')"
                            @end="onDragEnd"
                          >
                            <div
                              v-for="(box, index) in bronzeBoxes"
                              :key="index"
                              class="draggable-box bronze"
                              @dragstart="onDragStartItem(box, 'bronze', index)"
                              draggable="true"
                              @mouseover="bronzeHoveredName = box.companyName"
                              @mouseleave="bronzeHoveredName = ''"
                            >
                              {{ box.centerCode }}
                              <span v-if="bronzeHoveredName" class="tooltip">{{ bronzeHoveredName }}</span>
                            </div>
                          </draggable>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="round-count-section">
              <div class="divide-round">
                <div class="single-round">
                  <span>Round {{ alloctaedTotalCount?.round }}</span>
                </div>
                <div class="round-duration">
                  <span class="fnt-bold">Duration :</span>
                  {{ roundDuration }}
                </div>
              </div>
                <div class="round-count">
                  <div class="gold-center counter-centers">
                    <span>Schedule {{alloctaedTotalCount?.totalGold }} Gold Centers :</span>
                    <!-- <span class="total-bg">{{totalCount?.totalGold}}</span> -->
                    <span class="total-bg">{{goldScheduleCount}}</span>
                  </div>
                  <div class="silver-center counter-centers">
                    <span>Schedule {{alloctaedTotalCount?.totalSilver }} Silver Centers :</span>
                    <!-- <span class="total-bg">{{ totalCount?.totalSilver }}</span> -->
                    <span class="total-bg">{{silverScheduleCount }}</span>
                  </div>
                  <div class="bronze-center counter-centers">
                    <span>Schedule {{ alloctaedTotalCount?.totalBronze }} Bronze Centers :</span>
                    <!-- <span class="total-bg">{{ totalCount?.totalBronze }}</span> -->
                    <span class="total-bg">{{bronzeScheduleCount}}</span>
                  </div>
                </div>

                <!-- Calender Code -->

      <div id="app" class="app-container">
      <div class="calendar">
        <div class="calendar-header">
          <button class="today-button" @click="goToToday">Today</button>
          <div class="month-year-navigation">
            <button @click="changeMonthArrow('prev')" class="month-arrow">▲</button>
            <span class="month-year">{{ monthYear }}</span>
            <button @click="changeMonthArrow('next')" class="month-arrow">▼</button>
          </div>
          <div class="month-year-dropdown"></div>
        </div>
        <table class="calendar-table">
          <thead>
            <tr>
              <th v-for="day in daysOfWeek" :key="day" class="day-header">{{ day }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(week, weekIndex) in weeks" :key="weekIndex">
              <td
                v-for="(day, dayIndex) in week"
                :key="dayIndex"
                :class="{
                  'weekend': day && day.isWeekend,
                  'day-cell': day,
                  'today': day && isToday(day.date),
                  'has-item': day && day.items.length,
                  'selectedHighlightedDate': day && day.isSelected
                }"
                @drop="(e) => onDrop(e, day)"
                @dragover.prevent
                @dragenter.prevent
              >
                <div class="date-number">{{ day ? day.date.getDate() : '' }}</div>
                <div v-if="day">
                  <div
                    v-for="(item, itemIndex) in day.items"
                    :key="itemIndex"
                    :class="[item.name]"
                    @dragstart="onDragStartItem(item, 'calendar', itemIndex)"
                    draggable="true"
                    @mouseover="showTooltip(day, item)"
                    @mouseleave="hideTooltip"
                  >
                    {{ item.centerCode }}
                    <span v-if="tooltipVisible" class="tooltip">{{ tooltipText }}</span>
                    <button v-if="!isViewMode" @click="removeItem(day, item)" class="close-btn">x</button>
                  </div>
                </div>
                <div v-if="day && day.isToday" class="today-indicator"></div>
              </td>
            </tr>
          </tbody>
        </table>
              <div v-if="!isViewMode" class="calendar-footer">
                <button class="cancel-button"
                :class="{'blue-button': isDisabledCancelBtn, 'gray-button': !isDisabledCancelBtn, 'save-button': true}"
                :disabled="!isDisabledCancelBtn"
                @click="clearAllSchedules()"
                v-if="!isEditMode"
                >Cancel</button>

                <button
                :class="{'blue-button': isDisabledSaveBtn, 'gray-button': !isDisabledSaveBtn, 'save-button': true}"
                :disabled="!isDisabledSaveBtn"
                @click="saveSchedules()">Save</button>
              </div>
            </div>
          </div>
              </div>
          </div>
        </v-card>
      </v-container>
    </template>

<script>
import draggable from 'vuedraggable'
import stores from '../../../stores'
import constants from '../../../utils/constants'

export default {
  components: {
    draggable
  },
  data () {
    return {
      selectedDate: '',
      selectedDateString: this.formatDateToString(new Date()),
      amsUserID: stores.user.me.id,
      daysOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      weeks: [],
      goldBoxes: [],
      silverBoxes: [],
      bronzeBoxes: [],
      draggedItem: null,
      draggedSource: null,
      draggedItemIndex: null,
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth(),
      dropdownVisible: false,
      selctedRoundData: null,
      alloctaedTotalCount: null,
      totalCount: null,
      goldHoveredName: '',
      silverHoveredName: '',
      bronzeHoveredName: '',
      tooltipVisible: false,
      tooltipText: '',
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      scheduledItems: [],
      currentRoundId: '',
      viewSchedulingData: [],
      schedulingStatus: '',
      isViewMode: false,
      scheduledItemsID: [],
      centerList: [],
      schedulingAllDates: [],
      isEditMode: false,
      shedulingDataShow: [],
      errorMsg: 'error',
      successMsg: '#00C853',
      centerNameCodes: [],
      roundDuration: '',
      roundStartDate: '',
      goldScheduleCount: 0,
      silverScheduleCount: 0,
      bronzeScheduleCount: 0
    }
  },
  created () {
    const sharedData = JSON.parse(localStorage.getItem('selectedRoundData'))
    this.selectedDate = new Date(sharedData.roundStartDate)
    if (this.selectedDate) {
      this.currentYear = this.selectedDate.getFullYear()
      this.currentMonth = this.selectedDate.getMonth()
    }
    if (sharedData.selectedStatus === 'View' || sharedData.selectedStatus === 'Edit') {
      this.viewScheduling()
    } else {
      this.getCenterList()
    }
    this.generateCalendar()
  },
  mounted () {
    const sharedData = JSON.parse(localStorage.getItem('selectedRoundData'))
    this.selctedRoundData = sharedData
    this.currentRoundId = sharedData.roundID
    this.schedulingStatus = sharedData.selectedStatus
    if (sharedData.selectedStatus === 'View') {
      this.isViewMode = true
    } else if (sharedData.selectedStatus === 'Edit') {
      this.isEditMode = true
    }

    this.goldBoxes.sort((a, b) => {
      const aNumber = parseInt(a.centerCode.replace('G', ''), 10)
      const bNumber = parseInt(b.centerCode.replace('G', ''), 10)
      return aNumber - bNumber
    })
    this.silverBoxes.sort((a, b) => {
      const aNumber = parseInt(a.centerCode.replace('S', ''), 10)
      const bNumber = parseInt(b.centerCode.replace('S', ''), 10)
      return aNumber - bNumber
    })
    this.bronzeBoxes.sort((a, b) => {
      const aNumber = parseInt(a.centerCode.replace('B', ''), 10)
      const bNumber = parseInt(b.centerCode.replace('B', ''), 10)
      return aNumber - bNumber
    })
  },
  watch: {
    goldBoxes (count) {
      if (this.alloctaedTotalCount?.totalGold) {
        this.goldScheduleCount = count.length
      }
    },
    silverBoxes (count) {
      if (this.alloctaedTotalCount?.totalSilver) {
        // this.silverScheduleCount = this.alloctaedTotalCount?.totalSilver - count.length
        this.silverScheduleCount = count.length
      }
    },
    bronzeBoxes (count) {
      if (this.alloctaedTotalCount?.totalBronze) {
        this.bronzeScheduleCount = count.length
      }
    },
    selectedDateString (newDateString) {
      const dateObj = new Date(newDateString)
      this.selectedDate = dateObj
      this.currentMonth = dateObj.getMonth()
      this.currentYear = dateObj.getFullYear()
      // this.generateCalendar()
    },
    currentMonth (newMonth) {
      this.generateCalendar()
    },
    currentYear (newYear) {
      this.generateCalendar()
    },
    selectedDate (newDate) {
      if (typeof newDate === 'string') {
        const dateObj = new Date(newDate)
        this.currentMonth = dateObj.getMonth()
        this.currentYear = dateObj.getFullYear()
        this.generateCalendar()
      }
    }

  },
  methods: {
    showMessage (msg, msgType) {
      this.$dialog.notify.info(msg, {
        position: 'top-right',
        color: msgType,
        timeout: 2000
      })
    },
    showShedulingOnCalender () {
      let goldCount = 0
      let silverCount = 0
      let bronzeCount = 0
      this.shedulingDataShow.forEach((item, index) => {
        const scheduledDate = new Date(item.date)

        const isScheduled = this.scheduledItems.some(scheduledItem =>
          new Date(scheduledItem.date).toDateString() === scheduledDate.toDateString())

        if (isScheduled) {
          item.items.forEach((itemTemp) => {
            if (this.isEditMode) {
              if (itemTemp.name === 'Bronze') {
                itemTemp.centerCode = `B${bronzeCount + 1}`
                itemTemp.name = 'Bronze'
                bronzeCount++
              } else if (itemTemp.name === 'Silver') {
                itemTemp.centerCode = `S${silverCount + 1}`
                itemTemp.name = 'Silver'
                silverCount++
              } else if (itemTemp.name === 'Gold') {
                itemTemp.centerCode = `G${goldCount + 1}`
                itemTemp.name = 'Gold'
                goldCount++
              }
            }
            // Find the corresponding day on the calendar
            this.weeks.forEach((week) => {
              week.forEach((day) => {
                if (day && day.date.toDateString() === scheduledDate.toDateString()) {
                  const exists = day.items.some(existingItem => existingItem.id === itemTemp.id)
                  if (!exists) {
                    day.items.push(itemTemp)
                  }
                }
              })
            })
          })
        }
      })
    },
    formatDateToString (date) {
      return date.toISOString().substring(0, 10) // Format as 'YYYY-MM-DD'
    },
    onDateChange (dateString) {
      this.selectedDate = new Date(dateString)
      this.selectedDateString = dateString // Sync for display purposes
    },
    viewScheduling: async function () {
      try {
        const sharedData = JSON.parse(localStorage.getItem('selectedRoundData'))
        let payload = {
          'roundId': sharedData.roundID
        }
        if (!this.viewSchedulingData.length > 0) {
          const { data } = await http.post(`${constants.API_URL}/api/amsScheduling/createSchedule/getScheduleList`, payload)
          this.viewSchedulingData = data
        }
        this.viewSchedulingData.forEach((item, index) => {
          const scheduledDate = new Date(item.auditDate)

          if (this.isViewMode && !this.schedulingAllDates.includes(item.auditDate)) {
            this.schedulingAllDates.push(item.auditDate)
          }
          if (!this.scheduledItemsID.includes(item.franchiseeID)) {
            this.scheduledItemsID.push(item.franchiseeID)
          }
          const exists = this.scheduledItems.some(existingItem => {
            return existingItem.franchiseeId.toString() === item.franchiseeID.toString()
          })
          if (!exists) {
            if (!exists) {
              this.scheduledItems.push({
                franchiseeId: item.franchiseeID,
                date: item.auditDate
              })
            }
          }
          if (this.isViewMode) {
            if (item.FranchiseeName[0].amsCenterCategory.name === 'Bronze') {
              item.centerCode = `B${index + 1}`
              item.name = 'Bronze'
            } else if (item.FranchiseeName[0].amsCenterCategory.name === 'Silver') {
              item.centerCode = `S${index + 1}`
              item.name = 'Silver'
            } else if (item.FranchiseeName[0].amsCenterCategory.name === 'Gold') {
              item.centerCode = `G${index + 1}`
              item.name = 'Gold'
            }
            // Find the corresponding day on the calendar
            this.weeks.forEach((week) => {
              week.forEach((day) => {
                if (day && day.date.toDateString() === scheduledDate.toDateString()) {
                  const exists = day.items.some(existingItem => existingItem.franchiseeID === item.franchiseeID)
                  if (!exists) {
                    day.items.push(item)
                  }
                }
              })
            })
          }
        })

        if (this.isViewMode || this.isEditMode) {
          this.getCenterList()
        }
      } catch (error) {
        console.log('error ===>', error)
      }
    },
    saveSchedules: async function () {
      try {
        let payload = {
          roundId: this.currentRoundId,
          data: this.scheduledItems
        }
        if (this.isEditMode) {
          const { data } = await http.post(`${constants.API_URL}/api/amsScheduling/createSchedule/updateSchedules`, payload)
          if (data.message) {
            this.showMessage(data.message, this.success)
            this.$router.push({ name: 'createViewSchedule' })
          }
        } else {
          const { data } = await http.post(`${constants.API_URL}/api/amsScheduling/createSchedule/saveSchedules`, payload)
          if (data.message) {
            this.showMessage(data.message, this.success)
            this.$router.push({ name: 'createViewSchedule' })
          }
        }
      } catch (error) {
        console.log('saveSchedules error', error)
      }
    },
    clearAllSchedules: function () {
      this.scheduledItems = []
      this.shedulingDataShow = []
      this.generateCalendar()
      this.getCenterList()
    },
    getCenterList: async function () {
      try {
        const sharedData = JSON.parse(localStorage.getItem('selectedRoundData'))
        let payload = {
          'roundId': sharedData.roundID
        }
        if (this.centerList.length === 0) {
          const { data } = await http.post(`${constants.API_URL}/api/amsScheduling/createSchedule/getCenterList`, payload)
          this.alloctaedTotalCount = data.totalAllocatedCounts[0]
          this.totalCount = data.totalCount
          this.centerList = data.centerList
          this.roundStartDate = data.totalCount.startDate
          this.roundDuration = `${this.roundDateFormat(data.totalCount.startDate)} - ${this.roundDateFormat(data.totalCount.endDate)}`
          // this.selectedDate = new Date(data.totalCount.startDate)
        }

        if (this.isViewMode || this.isEditMode) {
          let goldCount = 0
          let silverCount = 0
          let bronzeCount = 0
          this.centerList.forEach((item) => {
            let existingId = this.scheduledItems.some(current => current.franchiseeId === item.id)
            if (!existingId && item.isActive === 1) {
              let targetArray, prefix, count

              if (item.name === 'Gold') {
                targetArray = this.goldBoxes
                prefix = 'G'
                count = goldCount
              } else if (item.name === 'Silver') {
                targetArray = this.silverBoxes
                prefix = 'S'
                count = silverCount
              } else if (item.name === 'Bronze') {
                targetArray = this.bronzeBoxes
                prefix = 'B'
                count = bronzeCount
              }

              if (targetArray && !targetArray.some(box => box.id === item.id)) {
                targetArray.push({
                  ...item,
                  centerCode: `${prefix}${count + 1}`
                })
                if (item.name === 'Gold') {
                  goldCount++
                } else if (item.name === 'Silver') {
                  silverCount++
                } else if (item.name === 'Bronze') {
                  bronzeCount++
                }
              }
            }
          })
        } else {
          this.centerList.forEach((item, index) => {
            if (item.isActive === 1) {
              let targetArray, prefix

              if (item.name === 'Gold') {
                targetArray = this.goldBoxes
                prefix = 'G'
              } else if (item.name === 'Silver') {
                targetArray = this.silverBoxes
                prefix = 'S'
              } else if (item.name === 'Bronze') {
                targetArray = this.bronzeBoxes
                prefix = 'B'
              }

              if (targetArray && !targetArray.some(box => box.id === item.id)) {
                if (item.name === 'Bronze') {
                }
                targetArray.push({
                  ...item,
                  centerCode: `${prefix}${targetArray.length + 1}`
                })
              }
            }
          })
        }
        if (this.isEditMode && this.shedulingDataShow.length === 0) {
          this.viewSchedulingData.forEach(schedule => {
            const matchedCenter = this.centerList.find(center => center.id === schedule.franchiseeID)
            if (matchedCenter) {
              const formatedDate = new Date(schedule.auditDate).toString()
              let itemDataArray = []
              itemDataArray.push(matchedCenter)
              let obj = {
                date: formatedDate,
                items: itemDataArray
              }
              this.shedulingDataShow.push(obj)
            }
          })

          this.shedulingDataShow.forEach((item, index) => {
            if (item.items[0].name === 'Bronze') {
              item.centerCode = `B${index + 1}`
              item.name = 'Bronze'
            } else if (item.items[0].name === 'Silver') {
              item.centerCode = `S${index + 1}`
              item.name = 'Silver'
            } else if (item.items[0].name === 'Gold') {
              item.centerCode = `G${index + 1}`
              item.name = 'Gold'
            }

            this.weeks.forEach((week) => {
              week.forEach((day) => {
                if (day && day.date.toDateString() === item.date.toDateString()) {
                  const exists = day.items.some(existingItem => existingItem.franchiseeID === item.items[0].id)
                  if (!exists) {
                    day.items.push(item)
                  }
                }
              })
            })
          })
        }
      } catch (e) {
        // this.isLoading = false
        // const errorMessage =
        //   (e && e.response && e.response.data.message) || e.message
        // this.errMsg(errorMessage)
      }
    },
    getvalidateHolidays: async function (item, day, date) {
      try {
        let payload = {
          'franchiseeId': item.id,
          'roundId': item.roundId,
          'date': date
        }
        const { data } = await http.post(`${constants.API_URL}/api/amsScheduling/createSchedule/validateHolidays`, payload)
        if (data.status === 417) {
          this.showMessage(data.message, this.errorMsg)
          this.removeItem(day, item)
        }
      } catch (error) {
        console.log('getvalidateHolidays error', error)
      }
    },

    highlightSelectedDate (selectedDate) {
      this.weeks.forEach((week) => {
        week.forEach((day) => {
          if (day && day.date.toDateString() === selectedDate.toDateString() &&
              day.date.getMonth() === this.currentMonth) {
            day.isSelected = true
          } else if (day) {
            day.isSelected = false
          }
        })
      })
    },
    generateCalendar () {
      if (!this.currentYear && !this.currentMonth) {
        const today = new Date()
        this.currentYear = today.getFullYear()
        this.currentMonth = today.getMonth()
      }
      const year = this.currentYear
      const month = this.currentMonth
      const firstDayOfMonth = new Date(year, month, 1)
      const lastDayOfMonth = new Date(year, month + 1, 0)
      const weeks = []
      let viewSchedulingCalled = false

      let currentWeek = []
      let startDay = firstDayOfMonth.getDay() - 1
      if (startDay === -1) startDay = 6

      for (let i = 0; i < startDay; i++) {
        currentWeek.push(null)
      }

      for (let day = 1; day <= lastDayOfMonth.getDate(); day++) {
        const date = new Date(year, month, day)
        const dayOfWeek = date.getDay()
        const isWeekend = dayOfWeek === 6 || dayOfWeek === 0
        const formattedDate = date.toISOString().split('T')[0]

        currentWeek.push({ date, isWeekend, items: [] })

        if (!viewSchedulingCalled && this.schedulingAllDates.length > 0 && this.schedulingAllDates.includes(formattedDate)) {
          viewSchedulingCalled = true
        }

        if (currentWeek.length === 7) {
          weeks.push(currentWeek)
          currentWeek = []
        }
      }

      while (currentWeek.length < 7) {
        currentWeek.push(null)
      }

      weeks.push(currentWeek)
      this.weeks = weeks

      // Highlight selected date if it is within the current month
      if (this.selectedDate &&
        this.currentMonth === this.selectedDate.getMonth() &&
        this.currentYear === this.selectedDate.getFullYear()) {
        this.highlightSelectedDate(this.selectedDate)
      }
      if (this.isViewMode || this.isEditMode) {
        this.viewScheduling()
      }
      if (!this.isViewMode) {
        this.showShedulingOnCalender()
      }
    },
    showTooltip (day, item) {
      if (item && item.companyName) {
        this.tooltipText = item.companyName
        this.tooltipVisible = true
      } else if (item && Array.isArray(item.FranchiseeName) && item.FranchiseeName.length > 0 && item.FranchiseeName[0]?.companyName) {
        this.tooltipText = item.FranchiseeName[0].companyName
        this.tooltipVisible = true
      }
    },

    hideTooltip () {
      this.tooltipVisible = false
      this.tooltipText = ''
    },

    findBox (item) {
      let allBoxes = [...this.goldBoxes, ...this.silverBoxes, ...this.bronzeBoxes]
      return allBoxes.find(box => box.centerCode === item)
    },
    onDragStart (source) {
      if (this.isViewMode) return
      this.draggedSource = source
    },
    onDragStartItem (item, source, index) {
      if (this.isViewMode) return
      this.draggedItem = item
      this.draggedSource = source
      this.draggedItemIndex = index
    },
    onDrop (event, day) {
      if (this.isViewMode) return
      event.preventDefault()
      const date = new Date(day.date)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-indexed
      const formatedDay = String(date.getDate()).padStart(2, '0')
      const formattedDate = `${year}-${month}-${formatedDay}`

      const isDatePresent = this.shedulingDataShow.some(item => {
        return new Date(item.date).toDateString() === date.toDateString()
      })
      if (!day.isWeekend && !this.isBeforeToday(day.date) && !isDatePresent) {
        this.scheduledItems = this.scheduledItems.filter(item => item.franchiseeId !== this.draggedItem.id)
        this.scheduledItems.push({
          franchiseeId: this.draggedItem.id,
          date: formattedDate
        })
        this.shedulingDataShow = this.shedulingDataShow.filter(item => item.items.some(i => i.id !== this.draggedItem.id && i.companyName !== this.draggedItem.companyName))
        this.shedulingDataShow.push(day)
        this.getvalidateHolidays(this.draggedItem, day, formattedDate)
      }

      if (day && this.draggedItem && !this.isBeforeToday(day.date)) {
        if (day.isWeekend || day.items.length >= 1) {
          return
        }

        this.removeItemFromSource(day)

        if (!day.items.includes(this.draggedItem)) {
          day.items.push(this.draggedItem)
        }

        this.draggedItem = null
        this.draggedSource = null
        this.draggedItemIndex = null
      }
    },
    isBeforeToday (dateString) {
      const inputDate = new Date(dateString)
      const today = new Date()
      // Remove time part for comparison
      inputDate.setHours(0, 0, 0, 0)
      today.setHours(0, 0, 0, 0)
      return inputDate < today
    },
    onDragEnd () {
      // if (this.isViewMode) return
      this.draggedItem = null
      this.draggedSource = null
      this.draggedItemIndex = null
    },
    removeItemFromSource (day) {
      if (this.isViewMode) return
      if (this.draggedSource === 'gold') {
        this.goldBoxes.splice(this.draggedItemIndex, 1)
      } else if (this.draggedSource === 'silver') {
        this.silverBoxes.splice(this.draggedItemIndex, 1)
      } else if (this.draggedSource === 'bronze') {
        this.bronzeBoxes.splice(this.draggedItemIndex, 1)
      } else if (this.draggedSource === 'calendar') {
        // Remove item from the previous day in calendar if it's already there
        this.weeks.forEach(week => {
          week.forEach(dayInWeek => {
            if (dayInWeek && dayInWeek.items.includes(this.draggedItem)) {
              const index = dayInWeek.items.indexOf(this.draggedItem)
              if (index !== -1) {
                dayInWeek.items.splice(index, 1)
              }
            }
          })
        })
      }
    },
    removeItem (day, item) {
      if (this.isViewMode) return

      if (day && day.items.includes(item)) {
        const index = day.items.indexOf(item)
        if (index !== -1) {
          day.items.splice(index, 1)
        }
        const date = new Date(day.date)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-indexed
        const formatedDay = String(date.getDate()).padStart(2, '0')
        const formattedDate = `${year}-${month}-${formatedDay}`
        this.scheduledItems = this.scheduledItems.filter(item => item.date !== formattedDate)

        this.shedulingDataShow = this.shedulingDataShow.filter(itemData => itemData.date !== day.date && itemData.items.some(i => i.companyName !== item.companyName))
        // Add item back to the source list
        if (item.centerCode.startsWith('G')) {
          this.goldBoxes.push(item)
        } else if (item.centerCode.startsWith('S')) {
          this.silverBoxes.push(item)
        } else if (item.centerCode.startsWith('B')) {
          this.bronzeBoxes.push(item)
        }
      }
    },
    isToday (date) {
      const today = new Date()
      return date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    },
    goToToday () {
      const today = new Date()
      this.currentYear = today.getFullYear()
      this.currentMonth = today.getMonth()
    },
    changeMonthArrow (direction) {
      if (direction === 'prev') {
        if (this.currentMonth === 0) {
          this.currentMonth = 11
          this.currentYear -= 1
        } else {
          this.currentMonth -= 1
        }
      } else if (direction === 'next') {
        if (this.currentMonth === 11) {
          this.currentMonth = 0
          this.currentYear += 1
        } else {
          this.currentMonth += 1
        }
      }
    },
    changeYear (direction) {
      if (direction === 'prev') {
        this.currentYear -= 1
      } else if (direction === 'next') {
        this.currentYear += 1
      }
    },
    toggleDropdown () {
      this.dropdownVisible = !this.dropdownVisible
    },
    changeMonth (index) {
      this.currentMonth = index
      this.dropdownVisible = false
    },
    roundDateFormat (dateStr) {
      const date = new Date(dateStr)
      const formattedDate = date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      })
      return formattedDate
    }
  },
  computed: {
    monthYear () {
      return `${this.months[this.currentMonth]} ${this.currentYear}`
    },
    isDisabledSaveBtn () {
      if (this.bronzeBoxes.length === 0) {
        return true
      } else {
        return false
      }
    },
    isDisabledCancelBtn () {
      return this.scheduledItems.length > 0
    }
  }
}
</script>

<style>
.blue-button{
  background-color: #007bff;
}
.gray-button{
  background-color: gray;
}
 .Bronze{
  background-color: #7a4503;
  color: #fff;
  border-radius: 8px;
  text-align: center;
  margin: 6px;
}
 .Silver{
  background-color: #9e9e9e;
  color: #fff;
  border-radius: 8px;
  text-align: center;
  margin: 6px;
}
 .Gold{
  background-color: gold;
  color: #fff;
  border-radius: 8px;
  text-align: center;
  margin: 6px;
}
  .app-container {
  padding: 14px 0px;
}
.selectedHighlightedDate{
  animation: blink 1s infinite;
  color: #000;
}
.calendar {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.calendar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background-color: #f3f4f6;
  border-bottom: 1px solid #ccc;
}

.today-button {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
}

.month-year-navigation {
  display: flex;
  align-items: center;
}

.month-arrow {
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.month-year {
  font-weight: bold;
  margin: 0 10px;
}

.month-year-dropdown {
  position: relative;
  cursor: pointer;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  padding: 10px;
  z-index: 10;
}

.year-arrow {
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.months-list {
  margin-top: 10px;
}

.months-list button {
  display: block;
  width: 100%;
  padding: 5px;
  text-align: left;
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.calendar-table {
  width: 100%;
  border-collapse: collapse;
}

.day-header {
  background-color: #007bff;
  color: white;
  padding: 10px;
  border-right: 1px solid #ccc;
  text-align: center;
}

.day-cell {
  width: 14.28%;
  height: 80px;
  text-align: center;
  vertical-align: top;
  border: 1px solid #ccc;
  position: relative;
  padding: 5px;
}

.today {
  background-color: #007bff7d !important;
  color: white;
}

/* .has-item {
  background-color: #e9ecef;
} */

.today-indicator {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 8px;
  height: 8px;
  background-color: green;
  border-radius: 50%;
}

.date-number {
  font-weight: bold;
  margin-bottom: 5px;
}

.scheduled-item {
  background-color: #d1ecf1;
  border: 1px solid #bee5eb;
  padding: 5px;
  margin: 2px 0;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
}

.close-btn {
  top: 2px;
  right: 2px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 16px;
  float: right;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  margin-right: 7px;
}

.calendar-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  background-color: #f3f4f6;
  border-top: 1px solid #ccc;
}
.cancel-button, .save-button {
  color: white;
  border: none;
  padding: 5px 10px;
  margin-left: 10px;
  border-radius: 4px;
  cursor: pointer;
}

.tooltip {
  position: absolute;
  bottom: 100%; /* Position the tooltip above the div */
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.75);
  color: #fff;
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0; /* Start with the tooltip hidden */
  pointer-events: none; /* Prevent tooltip from interfering with hover */
  transition: opacity 0.3s ease;
  z-index: 10;
}
.has-item:hover .tooltip {
  opacity: 1; /* Show tooltip on hover */
}
.has-item .tooltip {
  bottom: 60% !important;
}
.draggable-box:hover .tooltip {
  opacity: 1; /* Show tooltip on hover */
}
  .drag-drop-boxes td {
    vertical-align: top !important;
  }
  .total-bg{
    background-color: white;
    padding: 2px 20px 2px 20px;
    margin: 4px;
    min-width: 8%;
    text-align: center;
    border-radius: 8px;
  }
  .gold-col{
    padding: 4px;
    background-color: gold;
    /* border-radius: 8px; */
    border: 1px solid #000;
  }
  .bg-gold{
    background-color: gold;
    color: white;
    border: 1px solid #000 !important;
    /* width: 33%; */
  }
  .bg-silver{
    background-color: #9e9e9e;
    color: white;
    border: 1px solid #000 !important;
    /* width:  */
  }
  .bg-bronze{
    background-color: #7a4503;
    color: white;
    border: 1px solid #000 !important;
    /* width: 33%; */
  }
  .silver-col{
    padding: 4px;
    background-color: #9e9e9e;
    /* border-radius: 8px; */
    border: 1px solid #000;
  }
  .bronze-col{
    padding: 4px;
    background-color: #7a4503;
    /* border-radius: 8px; */
    border: 1px solid #000;
  }
  .drag-heading{
    text-align: center;
    font-weight: bold;
    margin-bottom: 8px;
  }
  .scheduling-main{
    margin-top: 16px;
  }
  .single-round{
    background-color: #f5f5f5;
    margin-bottom: 8px;
    width: 25%;
    padding: 8px;
    border-radius: 12px;
    text-align: center;
  }
  .round-count-section{
    width: 100%;
    padding: 0px 16px 0px 16px;
  }
  .counter-centers{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .round-count{
    background-color: #f5f5f5;
    padding: 8px;
    border-radius: 8px;
  }
  .app-container {
    display: flex;
  }
  .v-picker__body{
    border: 1px solid #eee;
  }
  .v-picker__title__btn{
    display: none;
  }
  .drag-drop-boxes {
    border: 1px solid #ddd;
    border-collapse: collapse;
    margin-top: 12px;
    padding: 8px;
    border-top-left-radius: 12px;
    background-color: #f5f5f5;
    border-top-right-radius: 12px;
  }
  .app-container .calendar {
    width: 100%;
    border: 1px solid #ddd;
    border-collapse: collapse;
    height: 100%;
    overflow: auto;
    position: relative;
  }

  .app-container .calendar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background-color: #f1f1f1;
    border-bottom: 1px solid #ddd;
  }

  .app-container .calendar-header button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
  }

  .app-container .calendar-header span {
    font-size: 18px;
    font-weight: bold;
  }

  .app-container .month-year-dropdown {
    position: relative;
  }

  .dropdown-menu {
    position: absolute;
    top: 100%;
    right: 0;
    border: 1px solid #ddd;
    background-color: white;
    padding: 10px;
    z-index: 10;
  }

  .months-list button {
    background: none;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
  }
  th{
    text-align: center !important;
  }

  .app-container .today-indicator {
    position: absolute;
    width: 8px;
    height: 8px;
    background-color: green;
    border-radius: 50%;
    top: 5px;
    right: 5px;
  }

  .txt-center {
    text-align: center !important;
  }
  .draggable-box {
    border: 1px solid #ccc;
    margin: 5px 0;
    padding: 10px;
    cursor: grab;
    position: relative;
  }

  .draggable-box.gold {
    background-color: #ccc;
    padding: 8px;
    margin: 8px;
    text-align: center;
    border-radius: 12px;
  }

  .draggable-box.silver {
    background-color: #ccc;
    padding: 8px;
    margin: 8px;
    text-align: center;
    border-radius: 12px;
  }

  .draggable-box.bronze {
    background-color: #ccc;
    padding: 8px;
    margin: 8px;
    text-align: center;
    border-radius: 12px;
  }

  .weekend {
    background-color: #e0e0e0;
    color: #000;
  }

  .app-container .day-cell {
    min-height: 100px;
    position: relative;
  }

  .app-container .scheduled-item {
    border: 1px solid #ccc;
    margin: 2px 0;
    padding: 2px 5px;
    cursor: grab;
    display: flex;
    justify-content: space-between;
  }
  .divide-round{
    display: flex;
  }
  .fnt-bold{
    color: #000;
    font-weight: bold;
  }
  .round-duration{
    background-color: #f5f5f5;
    margin-bottom: 8px;
    padding: 8px 16px;
    margin-left: 12px;
    border-radius: 12px;
    text-align: center;
  }
  @keyframes blink {
  0% {
    background-color: #f5f5f5;
  }
  50% {
    background-color: #eee;
  }
  100% {
    background-color: #f5f5f5;
  }
}
  </style>
